module.exports = __webpack_public_path__ + "img/option_three.95f0350d.png";